import React, { useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useI18n } from '../i18n';

export default function ContactPersonModal({
  open,
  onCancel,
  onSubmit,
  editingContactPerson,
}) {
  const [form] = Form.useForm();
  const { t } = useI18n();
  const isEditing = Boolean(editingContactPerson);

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue({
      name: editingContactPerson?.name || '',
      position: editingContactPerson?.position || '',
      email: editingContactPerson?.email || '',
      phone: editingContactPerson?.phone || '',
    });
  }, [editingContactPerson, form, open]);

  const handleFinish = async () => {
    const values = await form.validateFields();
    onSubmit(values);
  };

  return (
    <Modal
      title={isEditing ? t('Edit Contact Person') : t('Add Contact Person')}
      open={open}
      onCancel={onCancel}
      width={560}
      footer={[
        <Button key="cancel" onClick={onCancel}>{t('Close')}</Button>,
        <Button key="submit" type="primary" onClick={handleFinish}>
          {isEditing ? t('Update') : t('Create')}
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('Name')}
          name="name"
          rules={[{ required: true, message: t('Please enter name') }]}
        >
          <Input placeholder={t('Name')} />
        </Form.Item>
        <Form.Item label={t('Position')} name="position">
          <Input placeholder={t('Position')} />
        </Form.Item>
        <Form.Item
          label={t('Email')}
          name="email"
          rules={[{ type: 'email', message: t('Please enter a valid email address') }]}
        >
          <Input placeholder="email@example.com" />
        </Form.Item>
        <Form.Item label={t('Phone')} name="phone">
          <Input placeholder="+45 12 34 56 78" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
